export default {"src":"/_next/static/media/cdn.3dcba3f7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};